/* SHINYLIVING-SQUARE-NATIVE-RELOCATE-R2 — draft theme only, no synthetic buttons or storage. */
(function () {
  'use strict';
  function placeSquareWishlist() {
    var target = document.querySelector('.shiny-square-product-wishlist-target');
    var product = target && target.closest('product-info');
    if (!product) return;
    if (target.querySelector('.Vtl-WishlistButton__WishlistIconButton')) return;

    // Only use an existing Square widget inside THIS product's photo gallery.
    var media = product.querySelector('.product__media-wrapper');
    if (!media) return;
    var button = media.querySelector('.Vtl-WishlistButton__WishlistIconButton');
    if (!button) return;

    var widget = button.closest('[class*="Vtl-WishlistIcon__ProductPageWrapper"]');
    if (!widget || !media.contains(widget) || !widget.contains(button)) return;

    // Move the original Square node, preserving its native button/event handlers.
    target.appendChild(widget);
    widget.style.position = 'static';
    widget.style.inset = 'auto';
    widget.style.transform = 'none';
  }

  function init() {
    placeSquareWishlist();
    var product = document.querySelector('product-info');
    if (!product) return;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; placeSquareWishlist(); });
    });
    observer.observe(product, {subtree: true, childList: true});
    window.addEventListener('pagehide', function () { observer.disconnect(); }, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();